<div class="flex m-b-10 gap-10">
  <button mat-raised-button color="accent" (click)="onDumpState()">Capture Debug Data</button>
  <button mat-raised-button color="accent" [disabled]="disableCaptureMedia" (click)="onCaptureMedia()">
    {{ disableCaptureMedia ? 'Capture Media In Progress' : 'Capture Media Recording' }}
  </button>
</div>

<div class="flex flex-row">
  <mat-form-field appearance="fill">
    <mat-label>Is Moving Timeout Duration</mat-label>
    <input
      matInput
      id="isMovingTimeoutDuration"
      type="number"
      [(ngModel)]="isMovingTimeoutDuration"
      (ngModelChange)="isMovingTimeoutDurationUpdate()"
    />
  </mat-form-field>
</div>

<mat-divider></mat-divider>
<h4 class="m-t-10">Test User Commands</h4>

<div class="flex m-b-10 gap-10">
  <button mat-raised-button color="primary" (click)="onMuteTestUsers(true)">Mute Test Users</button>
  <button mat-raised-button color="primary" (click)="onMuteTestUsers(false)">Unmute Test Users</button>
</div>

<div class="flex gap-10">
  <mat-form-field appearance="fill">
    <mat-label>Test User Command</mat-label>
    <mat-select (selectionChange)="onTestUserCommandChange($event)" [(value)]="selectedTestUserCommand">
      <mat-option [value]="TestUserCommand.GROUP_SHARE">Start Group Share</mat-option>
      <mat-option [value]="TestUserCommand.END_SHARE">End Group Share</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Command Data</mat-label>
    <input matInput id="testUserCommandData" type="text" [(ngModel)]="testUserCommandData" />
  </mat-form-field>
</div>

<div class="m-b-10">
  <button mat-raised-button color="primary" (click)="onSendTestUserCommand()">Send Test User Command</button>
</div>

<mat-divider></mat-divider>

<div class="flex gap-10">
  <mat-form-field appearance="fill">
    <mat-label>Show Onboarding Experience</mat-label>
    <mat-select (selectionChange)="triggerOnboardingExperienceChange($event)" [(value)]="triggerOnboardingExperience">
      <mat-option [value]="true">Show Onboarding</mat-option>
      <mat-option [value]="false">Default Onboarding</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="flex m-b-10 m-t-10 gap-10">
  <button mat-raised-button color="primary" (click)="onResizeRoom(RoomSizeType.SMALL)">Small Room</button>
  <button mat-raised-button color="primary" (click)="onResizeRoom(RoomSizeType.MEDIUM)">Medium Room</button>
  <button mat-raised-button color="primary" (click)="onResizeRoom(RoomSizeType.LARGE)">Large Room</button>
  <button mat-raised-button color="primary" (click)="onResizeRoom(RoomSizeType.EXTRA_LARGE)">XLarge Room</button>
</div>

<div class="flex m-b-10 gap-10">
  <button mat-raised-button color="primary" (click)="onCreateUsers(1)">Create Fake User</button>
  <button mat-raised-button color="primary" (click)="onCreateUsers(10)">Create 10 Fake Users</button>
  <button mat-raised-button color="warn" (click)="onRemoveFakeUser()">Remove Fake User</button>
  <button mat-raised-button color="warn" (click)="onRemoveFakeUser(true)">Remove ALL Fake Users</button>
</div>

<div class="flex m-b-10 gap-10">
  <button mat-raised-button color="primary" (click)="onSetShowTimer(true)">Show timer</button>
  <button mat-raised-button color="primary" (click)="onSetShowTimer(false)">Hide timer</button>
</div>

<div class="m-b-10 gap-10">
  <button mat-raised-button color="primary" (click)="onTeleport()">Teleport</button>
  <mat-form-field appearance="fill">
    <mat-label>X</mat-label>
    <input matInput id="teleportX" type="text" [(ngModel)]="teleportX" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Y</mat-label>
    <input matInput id="teleportX" type="text" [(ngModel)]="teleportY" />
  </mat-form-field>
</div>

<div class="gap-10">
  <mat-form-field appearance="fill">
    <mat-label>Banner type</mat-label>
    <input matInput id="bannerType" type="text" [(ngModel)]="bannerType" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Message</mat-label>
    <input matInput id="bannerMessage" type="text" [(ngModel)]="bannerMessage" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Icon</mat-label>
    <input matInput id="bannerIcon" type="text" [(ngModel)]="bannerIcon" />
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>SVG Icon</mat-label>
    <input matInput id="bannerSVGIcon" type="text" [(ngModel)]="bannerSVGIcon" />
  </mat-form-field>
  <button mat-raised-button color="primary" (click)="showNewBanner()">Show new banner</button>
  <button mat-raised-button color="primary" (click)="removeBanner()">Remove banner</button>
</div>
